module.exports = "img/step2.989755.jpg";